import React, { useState } from 'react'
import { Form } from 'antd'
import type { PublicRequestOccasion } from 'apollo-gql'

import { VIDEO_REQUEST_OCCASION_ID } from 'components/ProductPage/shared/FieldConstants'

import CustomOccasionInput from './CustomOccasionInput'
import OccasionsList from './OccasionsList'

const isOther = (occasion: PublicRequestOccasion) =>
  occasion.internalName === 'other'

const getOther = (occasions: PublicRequestOccasion[]) =>
  occasions.find((o) => isOther(o))

const getOccasionsToDisplay = (
  occasions: PublicRequestOccasion[],
  limit: number,
) => [
  ...occasions.filter((o) => !isOther(o)).slice(0, limit - 1),
  ...[getOther(occasions)],
]

type OccasionItemsProps = {
  occasionsList: PublicRequestOccasion[]
  limit: number
  isMarketingRequest?: boolean
}

const OccasionItems: React.FC<OccasionItemsProps> = ({
  occasionsList,
  limit,
  isMarketingRequest = false,
}): JSX.Element => {
  const [selectedRequestOccasionId, setSelectedRequestOccasionId] =
    useState<string>()

  return (
    <>
      <Form.Item name={VIDEO_REQUEST_OCCASION_ID} noStyle>
        <OccasionsList
          occasions={getOccasionsToDisplay(occasionsList, limit)}
          setSelectedRequestOccasionId={setSelectedRequestOccasionId}
        />
      </Form.Item>

      {selectedRequestOccasionId === getOther(occasionsList)?.id && (
        <CustomOccasionInput isMarketingRequest={isMarketingRequest} />
      )}
    </>
  )
}

export default OccasionItems
